import { tClientLicence, tClientLicences } from 'common/modules/ReactShared';
import { createSelector, Selector } from '@reduxjs/toolkit';
import lessonSelectors from './lesson/selectors';
import type { tSharedAppState } from './types';
import { userSharedSelectors } from './user';

export const selectLessonAssignmentLicenses: Selector<tSharedAppState, tClientLicences> =
  createSelector(
    [lessonSelectors.selectLesson, userSharedSelectors.selectLightActiveLicences],
    (lessonData, activeLicenses) => {
      if (!lessonData || !lessonData.licensesWithAssignments) return [];
      const { licensesWithAssignments } = lessonData;
      return licensesWithAssignments
        .map((id) => activeLicenses.find((active) => active.id === id))
        .filter(Boolean) as NonNullable<tClientLicence>[];
    }
  );
